import { UseQueryResult } from '@tanstack/react-query'
import { Button, Card, CardBody, Spinner } from 'react-bootstrap'
import { Bilancia } from '../../types'
import dayjs from 'dayjs'
import { API_URL } from '../../constants'
import { fetchApi } from '@inmagik/react-crud'
import { useAuth } from '../../auth'
import { useRef, useState } from 'react'
import { usePartialUpdateBilancia } from '../../hooks/bilance'
import { toast } from 'react-toastify'

export default function CardCollaudo({
  bilancia,
}: {
  bilancia: UseQueryResult<Bilancia, Error>
}) {
  const [isDownloadingExcel, setIsDownloadingExcel] = useState(false)
  const { tokens } = useAuth()
  const inputRef = useRef<HTMLInputElement>(null)
  const { mutateAsync: updatePartialBilancia } = usePartialUpdateBilancia()
  return (
    <Card className="mt-3 mb-3">
      <CardBody>
        <div className="py-1 border-bottom d-flex justify-content-between">
          <div className="d-flex justify-content-between">
            <h4 className="heading-h4 d-flex align-items-center">
              Collaudo bilancia
            </h4>
          </div>
        </div>
        {!bilancia.data?.collaudo_xlsm && (
          <div className="mt-3">
            Scarica l'excel e ricaricalo compilato con i dati del collaudo.
          </div>
        )}
        {bilancia.data?.collaudo_xlsm && (
          <div className="mt-3">
            Visualizza l'excel caricato con i dati del collaudo.
          </div>
        )}
        {!bilancia.data?.collaudo_xlsm && (
          <div className="d-flex align-items-center">
            <Button
              variant="secondary"
              size="sm"
              className="text-white d-flex align-items-center mt-3"
              onClick={async () => {
                setIsDownloadingExcel(true)
                const data = await fetchApi(
                  `${API_URL}/bilance/bilancia/${bilancia?.data?.id}/download-excel-collaudo`,
                  {
                    method: 'GET',

                    headers: {
                      Authorization: 'Bearer ' + tokens?.access,
                    },
                  }
                )
                try {
                  const blob = await data.blob()
                  const contentDisposition = data.headers.get(
                    'Content-Disposition'
                  )
                  const filename = contentDisposition
                    ? contentDisposition.split('filename=')[1].replace(/"/g, '')
                    : `collaudo-${bilancia?.data?.matricola}.xlsx`
                  const url = window.URL.createObjectURL(new Blob([blob]))
                  const link = document.createElement('a')
                  link.href = url
                  link.setAttribute('download', filename)
                  document.body.appendChild(link)
                  link.click()
                  link.parentNode?.removeChild(link)
                } catch (e) {
                  toast.error("Errore nel download dell'excel", {
                    position: 'bottom-right',
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                  })
                } finally {
                  setIsDownloadingExcel(false)
                }
              }}
              disabled={isDownloadingExcel}
            >
              <span
                className="material-icons me-2"
                style={{
                  fontSize: '16px',
                }}
              >
                download
              </span>
              Scarica excel
              {isDownloadingExcel && (
                <Spinner
                  animation="border"
                  role="status"
                  size="sm"
                  className="ms-4"
                />
              )}
            </Button>
            <Button
              variant="outline-secondary"
              size="sm"
              className="text-secondary d-flex align-items-center mt-3 ms-3"
              onClick={() => {
                inputRef.current?.click()
              }}
            >
              <span
                className="material-icons me-2"
                style={{
                  fontSize: '16px',
                }}
              >
                upload
              </span>
              Carica excel
            </Button>
            <input
              ref={inputRef}
              type="file"
              className="d-none"
              accept=".xlsm,.xlsx"
              onChange={async (e) => {
                if (e.target.files && e.target.files[0]) {
                  await updatePartialBilancia({
                    id: bilancia.data?.id,
                    collaudo_xlsm: e.target.files[0],
                  }).then(() => {
                    toast.success('Excel caricato con successo', {
                      position: 'bottom-right',
                      autoClose: 5000,
                      hideProgressBar: false,
                      closeOnClick: true,
                      pauseOnHover: true,
                      draggable: true,
                      progress: undefined,
                    })
                  })
                }
              }}
            />
          </div>
        )}
        {bilancia.data?.collaudo_xlsm && (
          <div className="d-flex align-items-center">
            <Button
              variant="outline-secondary"
              size="sm"
              className="text-secondary d-flex align-items-center mt-3"
              onClick={async () => {
                await updatePartialBilancia({
                  id: bilancia.data?.id,
                  collaudo_xlsm: null,
                }).then(() => {
                  toast.success('Excel rimosso con successo', {
                    position: 'bottom-right',
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                  })
                })
              }}
            >
              <span
                className="material-icons me-2"
                style={{
                  fontSize: '16px',
                }}
              >
                delete
              </span>
              Rimuovi excel
            </Button>
            <Button
              variant="secondary"
              size="sm"
              className="text-white d-flex align-items-center mt-3 ms-3"
              onClick={() => {
                window.open(bilancia.data?.collaudo_xlsm as string, '_blank')
              }}
            >
              <span
                className="material-icons me-2"
                style={{
                  fontSize: '16px',
                }}
              >
                download
              </span>
              Scarica excel caricato
            </Button>
          </div>
        )}
      </CardBody>
    </Card>
  )
}
